<template>
  <div class="tianditu-map-container">
    <div class="search-box">
      <el-autocomplete
        v-model="address"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入关键词"
        @select="handleSelect"
        class="input-with-search"
        style="width: 100%"
      >
        <el-button slot="append" icon="el-icon-search" @click="searchAddress">
          搜索
        </el-button>
      </el-autocomplete>
      <div class="coordinates-display" v-if="longitude && latitude">
        经度: {{ longitude }}, 纬度: {{ latitude }}
      </div>
    </div>

    <div id="mapContainer" class="map-container"></div>
  </div>
</template>

<script>
export default {
  name: "TianDiTuMap",
  props: {
    // 初始经度
    initialLng: {
      type: [Number, String],
      default: 115.86,
    },
    // 初始纬度
    initialLat: {
      type: [Number, String],
      default: 28.69,
    },
    // 初始地址
    initialAddress: {
      type: String,
      default: "南昌市",
    },
    // 地图缩放级别
    zoom: {
      type: Number,
      default: 12,
    },
  },
  data() {
    return {
      map: null,
      marker: null,
      address: this.initialAddress,
      longitude: this.initialLng,
      latitude: this.initialLat,
      geocoder: null,
      isMapLoaded: false,
      localsearch: null,
      options: [],
    };
  },
  watch: {
    // 监听经纬度变化，更新地图
    initialLng(newVal) {
      if (newVal && this.isMapLoaded) {
        this.longitude = newVal;
        this.updateMarkerPosition();
      }
    },
    initialLat(newVal) {
      if (newVal && this.isMapLoaded) {
        this.latitude = newVal;
        this.updateMarkerPosition();
      }
    },
    // 监听地址变化
    initialAddress(newVal) {
      if (newVal && newVal !== this.address) {
        this.address = newVal;
        if (this.isMapLoaded) {
          this.searchAddress();
        }
      }
    },
  },
  mounted() {
    this.initTianDiTuMap();
  },
  methods: {
    // 初始化天地图
    initTianDiTuMap() {
      setTimeout(() => {
        // 创建地图实例
        this.map = new T.Map("mapContainer");

        // 设置地图中心点和缩放级别
        const center = new T.LngLat(this.longitude, this.latitude);
        this.map.centerAndZoom(center, this.zoom);

        // 创建标记
        this.marker = new T.Marker(center);
        this.map.addOverLay(this.marker);

        // 初始化地理编码服务
        this.geocoder = new T.Geocoder();

        // 配置本地搜索
        const config = {
          pageCapacity: 20, // 每页显示的数量
          onSearchComplete: (result) => {
            // 根据返回类型解析搜索结果
            if (parseInt(result.getResultType()) === 1) {
              // 解析点数据结果
              if (result.getPois()) {
                this.options = result.getPois().map((item) => {
                  return {
                    value: item.name,
                    address: item.address,
                    lonlat: item.lonlat,
                  };
                });
              } else {
                this.options = [];
              }
            }
          },
        };

        // 创建本地搜索对象
        this.localsearch = new T.LocalSearch(this.map, config);

        // 添加地图点击事件
        this.map.addEventListener("click", (e) => {
          const lnglat = e.lnglat;
          this.longitude = lnglat.lng;
          this.latitude = lnglat.lat;
          this.updateMarkerPosition();
          this.reverseGeocode(lnglat);
        });

        this.isMapLoaded = true;
        // 隐藏天地图logo和版权信息
        // setTimeout(() => {
        //   const logoElements = document.querySelectorAll(
        //     ".tdt-control-logo, .tdt-control-copyright, .tdt-control-attribution"
        //   );
        //   logoElements.forEach((element) => {
        //     element.style.display = "none";
        //   });
        // }, 1000);
        // 如果有初始地址，则进行搜索
        if (this.address) {
          this.searchAddress();
        } else if (this.longitude && this.latitude) {
          // 如果有初始经纬度，则进行反向地理编码
          this.reverseGeocode(new T.LngLat(this.longitude, this.latitude));
        }
      }, 500);
    },

    // 更新标记位置
    updateMarkerPosition() {
      if (this.map) {
        const position = new T.LngLat(this.longitude, this.latitude);

        // 清除旧标记
        this.map.clearOverLays();

        // 创建新标记
        this.marker = new T.Marker(position);
        this.map.addOverLay(this.marker);

        // 移动地图到新位置
        this.map.panTo(position);
      }
    },

    // 搜索地址
    searchAddress() {
      if (!this.address || !this.localsearch) return;

      this.localsearch.search(this.address, 7);

      // 使用地理编码服务获取精确位置
      if (this.geocoder) {
        this.geocoder.getPoint(this.address, (result) => {
          if (result && result.getStatus() === 0) {
            const point = result.getLocationPoint();
            this.longitude = point.lng;
            this.latitude = point.lat;
            this.updateMarkerPosition();

            // 向父组件发送经纬度变化事件
            this.$emit("location-change", {
              lng: this.longitude,
              lat: this.latitude,
              address: this.address,
            });
          }
        });
      }
    },

    // 反向地理编码（经纬度转地址）
    reverseGeocode(lnglat) {
      if (!this.geocoder) return;

      this.geocoder.getLocation(lnglat, (result) => {
        if (result && result.getStatus() === 0) {
          const addressComponent = result.getAddressComponent();

          // 构建完整地址，包含省市区
          let fullAddress = "";
          if (addressComponent.province)
            fullAddress += addressComponent.province;
          if (addressComponent.city) fullAddress += addressComponent.city;
          if (addressComponent.district)
            fullAddress += addressComponent.district;
          if (addressComponent.street) fullAddress += addressComponent.street;
          if (addressComponent.streetNumber)
            fullAddress += addressComponent.streetNumber;

          // 如果构建的地址为空，则使用原始地址
          this.address = fullAddress || addressComponent.address || "";

          // 向父组件发送地址变化事件
          this.$emit("address-change", {
            lng: this.longitude,
            lat: this.latitude,
            address: this.address,
            addressComponent: addressComponent,
          });
        }
      });
    },

    // 对外暴露的方法：设置位置
    setLocation(lng, lat) {
      this.longitude = lng;
      this.latitude = lat;
      this.updateMarkerPosition();
      this.reverseGeocode(new T.LngLat(lng, lat));
      return {
        lng: this.longitude,
        lat: this.latitude,
      };
    },

    // 对外暴露的方法：设置地址
    setAddress(address) {
      this.address = address;
      this.searchAddress();
    },

    // 获取当前位置信息
    getLocationInfo() {
      return {
        lng: this.longitude,
        lat: this.latitude,
        address: this.address,
      };
    },

    // 地址搜索建议
    querySearchAsync(queryString, cb) {
      if (this.localsearch && queryString) {
        this.localsearch.search(queryString, 7);
        setTimeout(() => {
          cb(this.options);
        }, 500);
      } else {
        cb([]);
      }
    },

    // 选择地址
    handleSelect(item) {
      if (item) {
        const lonlat = item.lonlat.split(",");
        const lng = parseFloat(lonlat[0]);
        const lat = parseFloat(lonlat[1]);

        this.longitude = lng;
        this.latitude = lat;
        this.address = item.address + item.value;

        this.map.clearOverLays();
        this.map.panTo(new T.LngLat(lng, lat));

        // 创建标记
        this.marker = new T.Marker(new T.LngLat(lng, lat));
        this.map.addOverLay(this.marker);

        // 向父组件发送位置变化事件
        this.$emit("location-change", {
          lng: this.longitude,
          lat: this.latitude,
          address: this.address,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .tdt-control-copyright{
  display: none;
}
.tianditu-map-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.search-box {
  margin-bottom: 10px;
}

.map-container {
  width: 100%;
  height: 500px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.coordinates-display {
  margin-top: 10px;
  color: #606266;
  font-size: 14px;
}

.input-with-search {
  width: 100%;
}
</style>